export default {
  country_locale: 'fr-BE',
  wia_title: 'Commençons par le produit :',
  wia_need_help: 'Vous avez besoin d\'aide',
  wia_model_name: 'Le nom du produit est',
  wia_back: '< changer',
  wia_confirm: 'Envoyer',
  wia_issue_title: 'Quel est le problème ?',
  wia_issue_concern: 'Quel problème avez-vous rencontré ?',
  wia_issue_specific: 'Un problème particulier',
  wia_possible_solution: 'Les solutions possibles',
  wia_solved_issue: 'Le problème est-il résolu ?',
  wia_closed: 'Fermez X',
  wia_feedback_ok: ' Oui !',
  wia_find_another_solution: 'Essayer une autre solution',
  wia_feedback_title: 'Nous sommes ravis d\'avoir pu vous aider !',
  wia_feedback_text1: 'Visitez notre boutique et découvrez les offres spéciales',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Découvrez nos formules de garantie',
  wia_smile_down_popup_title: 'Avez-vous encore besoin d\'aide ?',
  wia_smile_down_popup_text1: 'Passez à la deuxième étape',
  wia_smile_down_popup_or_text: 'ou',
  wia_smile_down_popup_text2: 'Organiser une intervention',
  wia_need_more_help: 'Avez-vous encore besoin d\'aide ?',
  wia_optional_label: '(optionnel)',
  wia_no_solution: 'Nous ne sommes pas parvenus à trouver une solution rapide mais ne vous inquiétez pas, nous pouvons toujours vous aider. Cliquez ici pour accéder à un support.',
  wia_all_solution: 'Tous les défauts par catégorie',
  wia_all_categories: 'Toutes les catégories',
  wia_seo_l1_issue: 'Tous les défauts par catégorie',
  wia_seo_wp_country_name: 'Belux',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'BE',
  wia_seo_wp_meta_title: 'Problèmes et solutions',
  wia_seo_bk_meta_title: 'Problèmes et solutions',
  wia_seo_hp_meta_title: 'Problèmes et solutions',
  wia_seo_id_meta_title: 'Problèmes et solutions',
  wia_seo_wp_meta_description: 'résolvez en quelques clics les problèmes de vos appareils électroménagers avec l\'assistance technique en ligne de European Appliances Belgium NV',
  wia_seo_bk_meta_description: 'résolvez en quelques clics les problèmes de vos appareils électroménagers avec l\'assistance technique en ligne de Bauknecht Belux',
  wia_seo_hp_meta_description: 'résolvez en quelques clics les problèmes de vos appareils électroménagers avec l\'assistance technique en ligne de Hotpoint Belux',
  wia_seo_id_meta_description: 'résolvez en quelques clics les problèmes de vos appareils électroménagers avec l\'assistance technique en ligne de Indesit Belux',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
